import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";

// Global CSS imports - moved from lazy-loaded components
import "./styles/fonts/brand-fonts.css";
import "./styles/LiveChatStyle.css";
import "./styles/createCoupon.css";
import "./styles/Popup.css";
import "./App.css";
import "./index.css";

// Third-party CSS imports
import "react-phone-input-2/lib/style.css";
import "react-phone-input-2/lib/bootstrap.css";
import "react-date-picker/dist/DatePicker.css";
import "react-time-picker/dist/TimePicker.css";
import "react-datepicker/dist/react-datepicker.css";
import "rc-swipeout/assets/index.css";

import { store } from "./store/index";
import App from "./App";

if (process.env.REACT_APP_SENTRY_KEY && process.env.REACT_APP_ENV !== "LOCAL") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    environment: process.env.REACT_APP_ENV,
  });
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
